import { render, staticRenderFns } from "./main.vue?vue&type=template&id=4d372ef9&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d372ef9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d372ef9')) {
      api.createRecord('4d372ef9', component.options)
    } else {
      api.reload('4d372ef9', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=4d372ef9&scoped=true", function () {
      api.rerender('4d372ef9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/documents/popup/condition-contact-fmt/main.vue"
export default component.exports